// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b0748933","977":"f49d09dd"}[chunkId] + ".chunk.js";
};